module.exports = __webpack_public_path__ + "static/media/face-male-2.004fd1ce.jpg";